import React from 'react';
import Icon from '@ant-design/icons';
import undo from '../../../assets/Svg/undo.png';
const UndoPng = () => <img src={undo} alt='' />;

const UndoIcon = (props) => <Icon component={UndoPng} {...props} />;

export default UndoIcon;
